import React from "react";
import { Card, Row, Col } from "reactstrap";
import {SubcourseData , ManageSubcourse} from "./AuthorSubcourseCards"
import EditNodes from "./EditNodes";

function getBreadcrums(breadc){ 
    let breadcrums = "";
    breadc.forEach(
        (breadcrum,index) => {
          `/ ${breadcrum} `;
          if(index === 0)
          {
              breadcrums = breadcrums + breadcrum;
          }
          else {
              breadcrums = breadcrums + ` / ` + breadcrum;
          }
        }
      );
return breadcrums;
}
export default class AuthorSubcourse extends React.Component {
  state ={
    activeCard : '',
    nodes: [
      { subcourseId: "01", name: "abc" },
      { subcourseId: "01", name: "sdf" },
      { subcourseId: "01", name: "sdsf" },
      { subcourseId: "01", name: "Challenger" },
      { subcourseId: "01", name: "mastery" },
      { subcourseId: "01", name: "asd" },
      { subcourseId: "01", name: "asdfsa" }
    ]
  }

  toggleRightCol = (activeCard) => {
      this.setState(state => ({ activeCard : activeCard === state.activeCard ? '' : activeCard }))
  }

  render() {
    let breadcrums = getBreadcrums([
      "ACT Mastery",
      "ACT Mastery English"
    ]);
    const { nodes, activeCard } = this.state;
    return (
      <Card className="course-edit-container">
        <span className='breadcrums'>{breadcrums}</span>
        <h3 className="heading pb-2">Edit <span className="name">ACT Mastery English</span> Subcourse   <i className="icon-delete-button" /></h3> 
      
        <Row>
          <Col style={{overflowY : 'auto'}} md={6} xs={12}>
            <SubcourseData nodes={nodes} toggleCard={this.toggleRightCol}/>
            <ManageSubcourse /> 
          </Col>
          <Col md={6} xs={12}>
          {activeCard === 'editNode'  && (
            <EditNodes
              closeEditNode={this.toggleRightCol}
              onUpdateNodes={nodes => this.setState({ nodes}, () => this.toggleRightCol)}
            />
          )}
          </Col>
          
        </Row>
           
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorSubcourse.js